function responseIsUnsuccessful(response) {
    return response.data == undefined || response.data.success != true;
}